import React, { createContext, useContext, useState } from "react";

const AlertDialogContext = createContext();

export function AlertDialog({ open, onOpenChange, children }) {
  return (
    <AlertDialogContext.Provider value={{ open, onOpenChange }}>
      {children}
    </AlertDialogContext.Provider>
  );
}

export function AlertDialogTrigger({ children }) {
  const { onOpenChange } = useContext(AlertDialogContext);
  return React.cloneElement(children, {
    onClick: () => onOpenChange(true),
  });
}

export function AlertDialogPortal({ children }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {children}
    </div>
  );
}

export function AlertDialogContent({ children }) {
  const { open, onOpenChange } = useContext(AlertDialogContext);
  if (!open) return null;

  return (
    <AlertDialogPortal>
      <div
        className="bg-white rounded-lg p-6 max-w-lg w-full"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </AlertDialogPortal>
  );
}

export function AlertDialogHeader({ children }) {
  return <div className="mb-4 text-left">{children}</div>;
}

export function AlertDialogFooter({ children }) {
  return <div className="mt-6 flex justify-end space-x-3">{children}</div>;
}

export function AlertDialogTitle({ children }) {
  return <h2 className="text-lg font-semibold text-gray-900">{children}</h2>;
}

export function AlertDialogDescription({ children }) {
  return <p className="text-sm text-gray-600 mt-1">{children}</p>;
}

export function AlertDialogCancel({ children }) {
  const { onOpenChange } = useContext(AlertDialogContext);
  return React.cloneElement(children, {
    onClick: () => onOpenChange(false),
    className:
      "px-4 py-2 border rounded hover:bg-gray-100 focus:outline-none focus:ring",
  });
}

export function AlertDialogAction({ children, onClick }) {
  const { onOpenChange } = useContext(AlertDialogContext);
  return React.cloneElement(children, {
    onClick: (e) => {
      if (onClick) onClick(e);
      onOpenChange(false);
    },
    className:
      "px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring",
  });
}
